import { PageHero } from "./Services";
import { BRAND } from "@/data/content";
import Seo from "@/components/Seo";

const SECTIONS = [
  {
    title: "1. Website Usage",
    body: (
      <p>
        By accessing or using petraloc.com, you agree to these Terms of Service and our Privacy
        Policy. The site is provided for informational and commercial-inquiry purposes only.
        Unauthorized scraping, reverse engineering, or attempts to interfere with site operations
        are strictly prohibited.
      </p>
    ),
  },
  {
    title: "2. Intellectual Property",
    body: (
      <p>
        All content, trademarks, logos, copy, code, graphics, and trade dress on this site are the
        exclusive property of Petraloc or its licensors and are protected by U.S. and international
        copyright, trademark, and trade-secret laws. No portion of this site may be reproduced,
        republished, or redistributed without prior written consent.
      </p>
    ),
  },
  {
    title: "3. Service Inquiries",
    body: (
      <p>
        Submissions made through our contact, quote, or support forms do not create a contractual
        relationship. Any engagement for translation, localization, interpretation, or AI services
        is governed by a separate Statement of Work or Master Services Agreement signed by both
        parties.
      </p>
    ),
  },
  {
    title: "4. Limitation of Liability",
    body: (
      <p>
        Petraloc and its officers, employees, and affiliates shall not be liable for any indirect,
        incidental, consequential, special, or punitive damages arising from your use of this
        website. Information published here is provided "as is" without warranties of any kind,
        express or implied.
      </p>
    ),
  },
  {
    title: "5. User Responsibilities",
    body: (
      <p>
        You agree to provide accurate, current, and complete information when submitting forms or
        contacting Petraloc. You also agree not to misuse the website, attempt unauthorized access,
        or upload content that is unlawful, infringing, or harmful.
      </p>
    ),
  },
  {
    title: "6. Third-Party Links",
    body: (
      <p>
        Our website may contain links to third-party websites or services that are not operated by
        Petraloc. We have no control over, and assume no responsibility for, the content, policies,
        or practices of any third-party sites or services.
      </p>
    ),
  },
  {
    title: "7. Governing Terms",
    body: (
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the State of
        Florida, United States, without regard to its conflict-of-law principles. Any dispute
        arising from these Terms shall be resolved in the competent courts located in Miami-Dade
        County, Florida.
      </p>
    ),
  },
  {
    title: "8. Contact Information",
    body: (
      <p>
        For questions regarding these Terms of Service, contact{" "}
        <a className="text-brand-blue underline" href={`mailto:${BRAND.email}`}>
          {BRAND.email}
        </a>{" "}
        or call {BRAND.phone}.
      </p>
    ),
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo
        title="Terms of Service"
        description="The terms that govern your use of the Petraloc website and any inquiries submitted through it."
        path="/terms"
      />
      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        subtitle="The terms that govern your use of the Petraloc website and any inquiries submitted through it."
      />

      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5B6472] mb-8 font-semibold">
            Effective date · February 2026
          </p>
          <div className="space-y-9">
            {SECTIONS.map((s) => (
              <div key={s.title} data-testid={`terms-section-${s.title.split(".")[0]}`}>
                <h2 className="text-xl lg:text-[22px] font-semibold text-[#071D49] mb-3 tracking-tight">
                  {s.title}
                </h2>
                <div className="text-[14.5px] text-[#222222] leading-relaxed">{s.body}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
